import React, {useEffect, useRef, useState} from 'react'
import {Button, Col, Form, Input, Modal, Row, Spin} from "antd";
import api from "../../api";

import debounce from 'lodash/debounce';
import CropSearchResults from "../CropSearchResults";
import {useTranslations} from "../../lang";


export default function SearchCropModal({addCropModalOpen, onCancel, onCropFound, onAddManually}) {
    const {translate} = useTranslations()
    const [addCropForm] = Form.useForm();
    const [searchResults, setSearchResults] = useState({})
    const [searching, setSearching] = useState(false)
    const searchInputRef = useRef(null)
    const query = new URLSearchParams(window.location.search).get('search')

    useEffect(() => {
        if(query) {
            addCropForm.getFieldValue('query') || addCropForm.setFieldsValue({query})
            handleSearch()
        }
    }, []);

    function handleSearch(e) {
        setSearchResults({})
        setSearching(true)
        api.search(addCropForm.getFieldValue('query')).then(setSearchResults).finally(() => setSearching(false))
    }

    function handleCropFound(crop) {
        onCropFound(crop)
        closeSearchModal()
    }

    function closeSearchModal() {
        setSearching(false)
        setSearchResults({})
        addCropForm.resetFields()
        onCancel()
    }

    return (
        <Modal open={addCropModalOpen}
               title={translate('Nieuw gewas toevoegen')}
               onCancel={closeSearchModal}
               afterOpenChange={(open) => { if (open) searchInputRef.current?.focus() }}
               footer={null}>
            <Form form={addCropForm} layout="vertical">
                <Row>
                    <Col span={18}>
                        <Form.Item label={translate('Zoek naar gewassen')} name="query">
                            <Input ref={searchInputRef} onChange={debounce(handleSearch, 300)}/>
                        </Form.Item>
                    </Col>
                    <Col span={6} className={"text-right"}>
                        <Form.Item label={" "}>
                            <Button type={"primary"} onClick={handleSearch} loading={searching} disabled={searching}>Zoeken</Button>
                        </Form.Item>
                    </Col>
                </Row>

                {searching && (
                    <div className={"text-center"}>
                        <Spin/>
                        <div>{translate('Een moment geduld, we zoeken nu naar gewassen...')}</div>
                    </div>
                )}
                {!searching && (
                    <>
                        <CropSearchResults
                            searchResults={searchResults}
                            onCropFound={handleCropFound}
                        />
                        <Button className={"mar-t-1"} onClick={onAddManually}>
                            {translate('Zoeken overslaan, zelf toevoegen')}
                        </Button>
                    </>
                )}
            </Form>
        </Modal>
    )
}
